{
  "nav": { "payroll": "Lương giáo viên" },
  "settings": {
    "menuItem": "Tiền công dạy",
    "title": "Tiền công dạy: {{name}}",
    "description": "Số tiền trung tâm trả cho giáo viên. Không liên quan tới học phí thu của học viên.",
    "rules": "Luật tiền công",
    "rulesHelper": "Áp dụng dòng có mức học viên cao nhất mà lớp vẫn đạt. Ví dụ: lớp 8 em, có luật từ 1 và từ 6 → tính theo dòng “từ 6”.",
    "ruleRole": "Vai",
    "ruleMinStudents": "Từ N học viên",
    "ruleRate": "Tiền công",
    "roleChinh": "Chính",
    "roleTroGiang": "Trợ giảng",
    "addRule": "Thêm luật",
    "removeRule": "Xoá dòng",
    "ruleDuplicate": "Đã có luật cho vai này ở mức {{minStudents}} học viên",
    "noRules": "Chưa có luật tiền công nào, bảng lương sẽ báo “Chưa có tiền công”.",
    "unit": "Tiền công tính theo",
    "perSession": "VNĐ/buổi",
    "perHour": "VNĐ/giờ",
    "exampleHour": "Buổi {{minutes}} phút → trả {{amount}}",
    "exampleSession": "Mỗi buổi → {{amount}}, dù buổi dài bao nhiêu",
    "baseSalary": "Lương cứng hằng tháng (tuỳ chọn)",
    "baseSalaryHelper": "Cộng thêm vào tiền công theo buổi mỗi tháng. Để trống nếu chỉ trả theo buổi.",
    "save": "Lưu",
    "saved": "Đã lưu tiền công",
    "slotOverride": "Tiền công riêng…",
    "slotOverrideHelper": "Bỏ trống = tính theo luật tiền công của giáo viên này. Chỉ ảnh hưởng tiền công, không liên quan học phí."
  },
  "page": {
    "title": "Lương giáo viên",
    "month": "Tháng",
    "export": "Xuất Excel",
    "exportDownloading": "Đang tải xuống...",
    "exportError": "Không thể xuất file lương",
    "branchNote": "Đang lọc theo chi nhánh, chỉ tính tiền buổi tại cơ sở này. Lương cứng, điều chỉnh và tổng chốt nằm ở chế độ Tất cả chi nhánh.",
    "warnBand": "{{count}} buổi đã qua chưa điểm danh, chưa được tính lương",
    "empty": "Chưa có giáo viên nào có buổi dạy trong tháng này",
    "noRateTitle": "Chưa đặt mức lương cho giáo viên nào",
    "noRateBody": "Đặt mức lương trong Thành viên & quyền, lương tính từ buổi đã điểm danh.",
    "noRateCta": "Thành viên & quyền",
    "loadError": "Không tải được bảng lương, thử lại.",
    "loadErrorRetry": "Thử lại",
    "rateUnset": "(chưa đặt)",
    "table": {
      "teacher": "Giáo viên",
      "payLink": "Tiền công",
      "sessions": "Buổi",
      "roleSplit": "{{main}} buổi chính · {{assistant}} buổi trợ giảng",
      "hours": "Giờ",
      "sessionPay": "Tiền theo buổi",
      "base": "Lương cứng",
      "adjustments": "Điều chỉnh",
      "total": "Tổng",
      "status": "Trạng thái"
    },
    "badges": {
      "finalized": "Đã chốt",
      "draft": "Nháp",
      "noRate": "Chưa có tiền công",
      "noRateRole": "Chưa có tiền công ({{role}})"
    },
    "roles": { "CHINH": "Chính", "TRO_GIANG": "Trợ giảng" },
    "expand": {
      "sessionsTitle": "Buổi dạy trong tháng",
      "noSessions": "Không có buổi dạy nào trong tháng này",
      "session": {
        "date": "Ngày",
        "subject": "Môn",
        "slot": "Lớp",
        "role": "Vai",
        "students": "Sĩ số",
        "minutes": "Phút",
        "rate": "Tiền công",
        "amount": "Thành tiền",
        "minutesShort": "{{count}}p",
        "studentsShort": "{{count}} HV",
        "overrideDot": "Tiền công riêng của khung giờ",
        "overrideLegend": "Tiền công riêng của khung giờ",
        "noRate": "Chưa có tiền công"
      },
      "exportTeacher": "Xuất bảng cho GV",
      "perSession": "/buổi",
      "perHour": "/giờ",
      "noAdjustments": "Chưa có khoản điều chỉnh nào",
      "viewExpense": "Xem khoản chi trong Sổ thu chi",
      "expenseDeleted": "Khoản chi của kỳ này đã bị xoá khỏi Sổ thu chi; tổng đã chốt vẫn giữ nguyên."
    },
    "card": {
      "sessions": "{{count}} buổi",
      "hours": "{{hours}} giờ",
      "rateLabel": "Tiền công",
      "sheetDescription": "Chi tiết lương tháng {{month}}"
    },
    "adjustment": {
      "addAdjustment": "Thêm điều chỉnh",
      "label": "Diễn giải",
      "labelPlaceholder": "VD: Thưởng, phạt trễ giờ...",
      "amount": "Số tiền (âm để trừ)",
      "amountZero": "Số tiền phải khác 0",
      "note": "Ghi chú (tuỳ chọn)",
      "add": "Thêm",
      "remove": "Xoá"
    },
    "confirm": {
      "finalizeTitle": "Chốt kỳ lương?",
      "finalizeBody": "Chốt lương tháng này cho {{name}} với tổng {{total}}. Một khoản chi sẽ được ghi vào Sổ thu chi.",
      "finalizeUnattended": "Vẫn còn buổi chưa điểm danh trong tháng, chốt nghĩa là trả không tính các buổi đó.",
      "finalizeUpcoming": "Tháng này còn {{count}} buổi chưa diễn ra của giáo viên này, chốt bây giờ thì các buổi đó sẽ không được tính vào kỳ nào.",
      "finalizeCta": "Chốt kỳ",
      "reopenTitle": "Mở lại kỳ lương?",
      "reopenBody": "Xoá dòng chi phí đã ghi và mở lại kỳ này?",
      "reopenCta": "Mở lại kỳ"
    },
    "toast": {
      "finalized": "Đã chốt lương",
      "reopened": "Đã mở lại tháng lương",
      "adjustmentAdded": "Đã thêm khoản điều chỉnh",
      "adjustmentRemoved": "Đã xoá khoản điều chỉnh"
    },
    "lockedCta": "Nâng cấp",
    "upsellTitle": "Ghi điều chỉnh và chốt/mở lại kỳ cần gói Pro",
    "upsellBody": "Bạn vẫn xem và xuất được bảng lương trên mọi gói. Nâng cấp lên Pro để thêm điều chỉnh, chốt và mở lại kỳ lương."
  }
}
